export function formatTel(text){
    var isPhone = /([0-9]{3,4}-)?[0-9]{7,8}/g;
    var isMob=/((\+?86)|(\(\+86\)))?(13[012356789][0-9]{8}|15[012356789][0-9]{8}|18[012356789][0-9]{8}|147[0-9]{8}|1349[0-9]{7})/g;
    //text=text.replace(isMob , 'dddd');  
   
    /**text=text.replace(isPhone , function($1){
        //alert(123)
      // return  "<a href='tel:"+$1+"'>"+$1+"</a>" ;
    });*/  
    text=text.replace(isMob , function($1){
        //alert(123)
        return  "<a href='tel:"+$1+"'>"+$1+"</a>" ;
     });  

     return text;

}





// WEBPACK FOOTER //
// ./static/js/tel.js